import React from 'react';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import PvsInventoryContainer from 'containers/PvsInventoryContainer';
import PvsInventoryView from 'views/components/PvsInventoryView/PvsInventoryView';
import { ThomasCampaignProduct } from 'models/interfaces';
import ThomasCampaignProductContainer from 'containers/ThomasCampaignProductContainer';
import './InventoryPage.scss';

interface InventoryPageProps {
  productId?: number;
}

interface InventoryPageState {
  productId?: number;
}

class InventoryPage extends React.Component<InventoryPageProps, InventoryPageState> {
  constructor(props: InventoryPageProps) {
    super(props);

    // default productId to PVS type
    const productId = props.productId || CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS;

    this.state = {
      productId
    };
  }

  renderProductInventory = () => {
    if (this.state.productId === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS) {
      return (
        <PvsInventoryContainer>
          {({ inventory }) => <PvsInventoryView inventory={inventory} />}
        </PvsInventoryContainer>
      );
    } else {
      return <p className="error">No product type selected</p>;
    }
  };

  render() {
    return (
      <section>
        <h1 className="page-title">
          PVS Inventory
          {/* <ThomasCampaignProductContainer>
            {({ products }) => (
             <span className="header-title-btn"> <select
                className="form-control inventory__product-select"
                value={this.state.productId}
                onChange={e => this.setState({ productId: parseInt(e.target.value) })}
              >
                <option value={0}>- Select -</option>
                {products.map((x: ThomasCampaignProduct) => (
                  <option value={x.product_id} key={x.product_id}>
                    {x.name}
                  </option>
                ))}
              </select></span>
            )}
          </ThomasCampaignProductContainer> */}
        </h1>
        {this.renderProductInventory()}
      </section>
    );
  }
}

export default InventoryPage;
